import { ChangeDetectionStrategy, Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { AlertService, AlertType } from 'src/app/shared/services/alert.service';
import { MedicFavoriteExternalPrescriptionService } from 'src/app/shared/services/API/medic/medic-favorite-external-prescription.service';
import { MedicFavoriteExternalPrescriptionStruct } from 'src/app/shared/services/structs/medic/medic-favorite-external-prescription.struct';

@Component({
  selector: 'app-select-favorite-external-prescription-modal',
  templateUrl: './select-favorite-external-prescription-modal.component.html',
  styleUrls: ['./select-favorite-external-prescription-modal.component.css'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class SelectFavoriteExternalPrescriptionModalComponent implements OnInit {
  
  constructor(@Inject(MAT_DIALOG_DATA) public data: any,
    public matDialogRef: MatDialogRef<SelectFavoriteExternalPrescriptionModalComponent>,
    private alertService: AlertService,
    private favoriteExternalPrescriptionService: MedicFavoriteExternalPrescriptionService,
    private formBuilder: FormBuilder
  ) { }

  public model: FormGroup;
  public listMedicFavoritePrescription: MedicFavoriteExternalPrescriptionStruct[] = [];
  public loading: boolean = false;
  public selected: boolean = false;
  public selectedFavoriteText: string = "";

  ngOnInit(): void {
    this.model = this.formBuilder.group({
      idMedicFavoriteExternalPrescription: ['', [Validators.required]]
    });
    this.getAllFavoritePrescriptions();
  }

  getAllFavoritePrescriptions() {
    this.loading = true;
    this.favoriteExternalPrescriptionService.listMedicFavoriteExternalPrescription().subscribe({
      next: (response: any) => {
        if (response.isError) {
          this.alertService.show('Erro', response.errorDescription, AlertType.error);
          this.loading = false;
          return;
        }
        this.listMedicFavoritePrescription = response.listMedicFavoriteExternalPrescriptionStruct;
        this.loading = false;
        
        if (!this.listMedicFavoritePrescription || this.listMedicFavoritePrescription.length === 0)
          this.alertService.show('Aviso', 'Não há prescrições favoritadas', AlertType.warning);
      },
      error: (error: string) => {
        this.loading = false;
        this.alertService.show('Erro inesperado', error, AlertType.error);
      }
    });
  }

  loadPrescription(event: any) {
    if (!event.value || event.value == 0) {
      this.selected = false;
      return;
    }
    
    const favorite = this.listMedicFavoritePrescription.find(x => x.idMedicFavoriteExternalPrescription === event.value);
    if (favorite) {
      this.selectedFavoriteText = favorite.formattedText;
      this.selected = true;
    }
  }

  clickCancel() {
    this.matDialogRef.close({});
  }

  clickAdd() {
    this.matDialogRef.close({
      selected: this.selected,
      formattedText: this.selectedFavoriteText,
    });
  }
}